import moment from 'moment';

export const AT_RETIREMENT = -1;
export const STARTS_TODAY = -2;

export const getDisplayDate = (year: number = new Date().getFullYear()) => {
  return year === AT_RETIREMENT
    ? 'At Retirement'
    : year === STARTS_TODAY
    ? 'Starts today'
    : moment([year]).format('YYYY');
};
